import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/vsts/work/1/source/frontend/layouts/default.vue").then(m => m.default || m))
}